module.exports = __webpack_public_path__ + "static/media/link_chain.c2f01370.svg";